<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{
  type: "white" | "gold";
}>();
</script>

<template>
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="transition-colors duration-300 ease-in-out"
  >
    <rect
      x="0.5"
      y="0.5"
      width="55"
      height="55"
      rx="27.5"
      class="transition-colors duration-300 ease-in-out group-hover:fill-white"
      :class="props.type === 'white' ? 'stroke-white' : 'stroke-gold'"
    />
    <path
      d="M35.6364 37.2727H20.3636C19.2067 37.2715 18.0975 36.8114 17.2794 35.9933C16.4614 35.1752 16.0012 34.066 16 32.9091V23.0909C16.0012 21.934 16.4614 20.8248 17.2794 20.0067C18.0975 19.1887 19.2067 18.7285 20.3636 18.7273H35.6364C36.7933 18.7285 37.9025 19.1887 38.7206 20.0067C39.5386 20.8248 39.9988 21.934 40 23.0909V32.9091C39.9988 34.066 39.5386 35.1752 38.7206 35.9933C37.9025 36.8114 36.7933 37.2715 35.6364 37.2727ZM20.3636 20.9091C19.7852 20.9098 19.2306 21.1399 18.8216 21.5489C18.4126 21.9579 18.1825 22.5125 18.1818 23.0909V32.9091C18.1825 33.4876 18.4126 34.0421 18.8216 34.4512C19.2306 34.8602 19.7852 35.0903 20.3636 35.0909H35.6364C36.2148 35.0903 36.7694 34.8602 37.1784 34.4512C37.5874 34.0421 37.8175 33.4876 37.8182 32.9091V23.0909C37.8175 22.5125 37.5874 21.9579 37.1784 21.5489C36.7694 21.1399 36.2148 20.9098 35.6364 20.9091H20.3636Z"
      class="transition-colors duration-300 ease-in-out group-hover:fill-active"
      :class="props.type === 'white' ? 'fill-white' : 'fill-gold'"
    />
    <path
      d="M27.9999 29.5639C26.7865 29.5644 25.6076 29.1596 24.6504 28.4139L17.5115 22.8613C17.2831 22.6836 17.1346 22.4224 17.0987 22.1352C17.0629 21.848 17.1426 21.5583 17.3203 21.3299C17.498 21.1014 17.7592 20.953 18.0464 20.9171C18.3336 20.8812 18.6233 20.9609 18.8517 21.1387L25.9906 26.6912C26.5647 27.1389 27.2718 27.382 27.9998 27.382C28.7278 27.382 29.4349 27.1389 30.009 26.6912L37.1479 21.1387C37.3763 20.9609 37.666 20.8812 37.9532 20.9171C38.2404 20.953 38.5016 21.1014 38.6793 21.3299C38.857 21.5583 38.9367 21.848 38.9009 22.1352C38.865 22.4224 38.7165 22.6836 38.4881 22.8613L31.3492 28.4139C30.3919 29.1594 29.2132 29.5641 27.9999 29.5639Z"
      class="transition-colors duration-300 ease-in-out group-hover:fill-active"
      :class="props.type === 'white' ? 'fill-white' : 'fill-gold'"
    />
  </svg>
</template>
